var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c(_vm.component_name,_vm._g(_vm._b({tag:"component"},'component',_vm.component_props,false),_vm.$listeners))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }